export const languages = [
  {
    name: "English",
    icon: "en",
    locale: "en"
  },
  {
    name: "French",
    icon: "fr",
    locale: "fr"
  }
];
